import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { CONSTANTS } from "../../../../../Constants/Constants";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { TranslatePipe } from "@ngx-translate/core";
import { CommonDataService } from "../../../../../services/common-data.service";

@Component({
    selector: 'app-sol-properties-travel-settings',
    templateUrl: './sol-properties-travel-settings.component.html',
    styleUrls: ['./sol-properties-travel-settings.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        NgxMaskDirective,
        TranslatePipe
    ],
    providers: [provideNgxMask()]
})
export class SolPropertiesTravelSettingsComponent implements OnInit {
    travelSettingsForm!: FormGroup<{
        diemRate: FormControl<number>; 
        mileageRate: FormControl<number>;
        lodgingRate: FormControl<number>;
        parkingRate: FormControl<number>;
        tollsRate: FormControl<number>;
        mileageRT: FormControl<number>;
    }>;
    private destroyRef = inject(DestroyRef);

    constructor(private readonly fb: NonNullableFormBuilder,
        private readonly commonDataService: CommonDataService
    ) { }
    
    ngOnInit(): void {
        this.initializeForm();
        this.setupReadOnlyMode();
    }

    private setupReadOnlyMode(): void {
        this.commonDataService.readOnlyMode$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(isReadOnly => {
                if (isReadOnly) {
                    this.travelSettingsForm.disable({ emitEvent: false });
                } else {
                    this.travelSettingsForm.enable({ emitEvent: false });
                }
            });
    }

    private initializeForm(): void {
        this.travelSettingsForm = this.fb.group({
            diemRate: this.fb.control<number>(CONSTANTS.ZERO),
            mileageRate: this.fb.control<number>(CONSTANTS.ZERO),
            lodgingRate: this.fb.control<number>(CONSTANTS.ZERO),
            parkingRate: this.fb.control<number>(CONSTANTS.ZERO),
            tollsRate: this.fb.control<number>(CONSTANTS.ZERO),
            mileageRT: this.fb.control<number>(CONSTANTS.ZERO)
        });
    }

}